
export enum INVOICE_TAB {
    ALL,
    PAID,
    UNPAID,
    DRAFT,
    DEBT_COLLECTION,
}